import { render, staticRenderFns } from "./EstablishmentStateAnswerTextValidation.vue?vue&type=template&id=19873207&scoped=true&"
import script from "./EstablishmentStateAnswerTextValidation.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentStateAnswerTextValidation.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentStateAnswerTextValidation.vue?vue&type=style&index=0&id=19873207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19873207",
  null
  
)

component.options.__file = "EstablishmentStateAnswerTextValidation.vue"
export default component.exports